import EntityModel from '@/common/models/entity-model';
import RuleModel from './rule-model';
import BindModel from './bind-model';

export default class RuleSetModel extends EntityModel {
    hydrate({
        version = null,
        updatedTime = null,
        createdTime = null,
        rules = [],
        binds = [],
    } = {}) {
        this.version = version;
        this.updatedTime = updatedTime;
        this.createdTime = createdTime;
        this.rules = rules.map((rule, order) => new RuleModel({...rule, order}));
        this.binds = binds.map((bind, order) => new BindModel({...bind, order}));
    }

    get rulesCount() {
        return this.rules.length;
    }

    get bindsCount() {
        return this.binds.length;
    }

    getPayload() {
        return {
            rules: this.rules.map(rule => rule.getPayload()),
            binds: this.binds.map(bind => bind.getPayload()),
        };
    }

    addIntegration(bind) {
        this.binds.push(bind);
    }

    removeIntegration(integrationPrefix) {
        this.binds = this.binds.filter(
            bind => bind.labels.find(label => !label.startsWith(integrationPrefix)),
        );
    }
}
